import React from "react";
import { withRouter } from "react-router-dom";


/**
 * ScrollToTop Component
 * Responsible to scroll to the top of every screen (Routes) when they're clicked.
 * It shall be rendered on top of the App component.
 * 
 * Without the use of this component any screens would start in the scrolling location
 * of the previous screen.
 */
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}



export default withRouter(ScrollToTop);